import PlaygroundPage from './PlaygroundPage';

export default PlaygroundPage;